import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, firstValueFrom, of } from 'rxjs';
import { AuthService } from './auth.service';
import { loginRedirectTo } from './login-redirect';

type AdminRoleCheck = (auth: AuthService) => boolean;

function adminRoleGuard(hasRole: AdminRoleCheck): CanActivateFn {
  return async (_route, state) => {
    const auth = inject(AuthService);
    const router = inject(Router);

    if (!auth.isLoggedIn()) return loginRedirectTo(router, state.url);

    if (!hasRole(auth)) {
      await firstValueFrom(auth.loadProfile().pipe(catchError(() => of(null))));
    }

    return hasRole(auth) ? true : router.createUrlTree(['/']);
  };
}

export const adminGuard = adminRoleGuard((auth) => auth.canAccessAdmin());
export const platformAdminGuard = adminRoleGuard((auth) => auth.isPlatformAdmin());
export const gemeindeOrPlatformAdminGuard = adminRoleGuard(
  (auth) => auth.isPlatformAdmin() || auth.isGemeindeAdmin(),
);
